/**
 * Model to hold a single event contact.
 */
export class Contact {
    public id: string;
    public name: string;
    public title: string;
    public phone: string;
    public email: string;

    public clone(): Contact {
        const clone: Contact = new Contact();
        clone.id = this.id;
        clone.name = this.name;
        clone.title = this.title;
        clone.phone = this.phone;
        clone.email = this.email;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'contact';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.title = this.title;
        json.data.attributes.phone = this.phone;
        json.data.attributes.email = this.email;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: Object): Contact {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.title = attrs['title'];
        this.phone = attrs['phone'];
        this.email = attrs['email'];

        return this;
    }
}
